import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { DPEApi } from "@socotec.io/atm-back-sdk";
import { listAllPages } from "@/api/utils/sdk";

const api = new DPEApi(atmBackConfiguration);

export const fetchDpeWindowsAreaCalculationLines = async ({ zone } = {}) => {
  return listAllPages((page) => api.list({ zone, page }));
};

export const createDpeCalculationLine = async (dpeCalculationLineData) => {
  return await api.create({
    dpeWindowsAreaCalculationLineRequest: dpeCalculationLineData,
  });
};

export const destroyDpeWindowsAreaCalculationLine = async (uuid) => {
  await api.destroy({ uuid });
};

export const updateDpeWindowsAreaCalculationLine = async (dpeWindowsAreaCalculationLineData) => {
  const { uuid, ...rest } = dpeWindowsAreaCalculationLineData;
  return await api.partialUpdate({
    uuid,
    patchedDpeWindowsAreaCalculationLineRequest: rest,
  });
};

/**
 * @param {{uuids: string[], case: string}} payload AOS building uuids + the case
 * uuid the generated CSV is attached to (uploaded server-side as a document)
 */
export const createDpeCsv = async ({ uuids, case: caseUuid }) => {
  await api.exportCsv({ dpeExportCsvRequest: { uuids, _case: caseUuid } });
};
